export default {
  noteContainer:
    'whitespace-pre-wrap wrap-break-word break-all block font-sans w-full',
};
